import { StoryblokEditable } from '@activebrands/core-web/libs/storyblok/storyblok';
import { styled } from '@activebrands/core-web/libs/styletron';
import AccordionPanel from 'components/accordion/AccordionPanel';
import Modules from 'libs/storyblok/content/Modules';

const ContentWrapper = styled('div', {
    padding: '16px 0',
});
const AccordionWrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
});

type StoryblokAccordionBlocks =
    | { component: 'textModule'; _uid: string; [key: string]: any }
    | { component: 'backgroundMediaModule'; _uid: string; [key: string]: any }
    | { component: 'videoPlayerModule'; _uid: string; [key: string]: any }
    | { component: 'buttonsListModule'; _uid: string; [key: string]: any };

interface AccordionItem {
    _uid: string;
    name: string;
    blocks: StoryblokAccordionBlocks[];
    anchorTag: string;
}

interface AccordionProps {
    id?: string;
    items?: AccordionItem[];
    sbEditable?: StoryblokEditable;
}

const Accordion = ({ id, items = [], sbEditable }: AccordionProps) => {

    if (!items.length) {
        return null;
    }

    return (
        <AccordionWrapper id={id} {...sbEditable}>
            {items.map(item => (
                <AccordionPanel
                    id={item.anchorTag}
                    $style={{ width: ['100%', null, null, null, null, '50%'] }}
                    labelTextStyle='Primary/16_100_-05_500'
                    key={item._uid}
                    label={item.name}
                    name={item._uid}
                    render={() => (
                        <ContentWrapper>
                            {(Modules as any)({ isFullWidth: true, modules: item.blocks })}
                        </ContentWrapper>
                    )}
                />
            ))}
        </AccordionWrapper>
    );
};

export default Accordion;
